export const IMG_URL_PREFIX : string = "https://bookshelf-spines.s3.amazonaws.com/";
